import styled from 'styled-components';

export const SignInContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 380px;

    @media screen and (max-width: 375px) {
        width: 300px;
    }


    h2 {
        margin: 10px 0px;
    }
`

export const ButtonsContainer = styled.div`
    display: flex;
    justify-content: space-between;

     @media screen and (max-width: 375px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }
`
